export
const name: string = "ShadowMapBlur";

export
const preproc: string = `
    //#version 100
`;

export
const declaration: string = `
    attribute vec3 a_position;
    attribute vec2 a_texcoords;
`;

export
const varyings: string = `
    varying vec2 v_texcoords;
`;

export
const implementation: string = `
    void main() {
        v_texcoords = a_texcoords;
        gl_Position = vec4(a_position, 1.0);
    }
`;
